<template>
	<v-app theme="light" class="nis-app" style="background-color: #eeeeee !important">
		<nav-bar-nis />
		<VMain class="nis-main" style="background-color: #eeeeee !important">
			<div class="nis-page-bg">
				<breadcrumbs />
				<router-view class="secondary--text" />
			</div>
		</VMain>
		<test-error />
		<orixe-footer />
	</v-app>
</template>

<script>
export default {
	name: "NisView",
	mounted() {
		document.body.style.backgroundColor = "#eeeeee"
	},
	beforeDestroy() {
		document.body.style.backgroundColor = ""
	},
}
</script>

<style>
.nis-app.v-application,
.nis-app.theme--light.v-application,
.nis-app .v-application--wrap {
	background: #eeeeee !important;
	background-color: #eeeeee !important;
}
.nis-main.v-main,
.nis-main .v-main__wrap {
	background: #eeeeee !important;
	background-color: #eeeeee !important;
}
.nis-page-bg {
	background-color: #eeeeee !important;
	min-height: calc(100vh - 64px);
	width: 100%;
	padding-bottom: 24px;
}
/* White cards on grey page — restore gap under breadcrumb so grey shows */
.nis-page-bg .contentRow {
	background-color: #fff !important;
}
.nis-page-bg > .container {
	background-color: transparent !important;
}
.nis-page-bg > .container > .row.contentRow.mb-0 {
	margin-bottom: 36px !important;
}
</style>
